import * as React from 'react';
import { DMButton, DMDiv } from '../Primitives';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export const Toggle = ({
  checked,
  onChange,
  disabled = false,
}: ToggleProps) => (
  <DMButton
    type="button"
    disabled={disabled}
    onClick={() => onChange(!checked)}
    className={`w-[4.4vh] h-[2.4vh] rounded-[2vh] p-[0.3vh] transition-colors duration-200 ease-in-out disabled:cursor-not-allowed disabled:opacity-60 ${
      checked ? 'bg-primary-main' : 'bg-gray-200'
    }`}
  >
    <DMDiv
      className={`w-[1.8vh] h-[1.8vh] bg-white rounded-full shadow-sm transform transition-transform duration-200 ease-in-out ${
        checked ? 'translate-x-[2vh]' : 'translate-x-0'
      }`}
    />
  </DMButton>
);
